export default {
    NUMBERS: /^[0-9]+$/,
}